import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import moment from 'moment';
import { Button } from '@jem-open/jem-ui';
import { environment } from '../../../environment/environment';
import { DataTable } from '../../../components/DataTable';
import { EmptyState } from '../../../components/EmptyState';

const SubscriptionBatchList = (props) => {
  const {
    subscriptionBatches,
    handleShowBatchItemsModal,
    isLoading = false,
  } = props;

  const safeBatches = Array.isArray(subscriptionBatches)
    ? subscriptionBatches
    : [];

  const columns = [
    { key: 'id', label: 'ID', width: '80px' },
    {
      key: 'employer',
      label: 'Employer',
      width: '210px',
      className: 'max-w-[210px]',
      render: (value, batch) => (
        <div className="w-full truncate" title={batch.employer?.companyName}>
          {batch.employer?.companyName}
        </div>
      ),
    },
    {
      key: 'subscription',
      label: 'Subscription',
      width: '220px',
      className: 'max-w-[220px]',
      render: (value, batch) => (
        <div className="w-full truncate" title={batch.subscription?.name}>
          {batch.subscription?.name}
        </div>
      ),
    },
    {
      key: 'dateRange',
      label: 'Date Range',
      render: (value, batch) =>
        `${moment(batch.startDate).format('DD/MM/Y, h:mm a')} - ${moment(
          batch.endDate
        ).format('DD/MM/Y, h:mm a')}`,
    },
    {
      key: 'requestedBy',
      label: 'Requested By',
      render: (value, batch) => batch.requestedBy?.username,
    },
    {
      key: 'dateCreated',
      label: 'Date Created',
      width: '170px',
      render: (value, batch) =>
        moment(batch.dateCreated).format('DD MMM YY, h:mm a'),
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '250px',
      render: (value, batch) => (
        <div className="flex items-center gap-xs">
          <Button
            size="sm"
            variant="outline"
            onClick={() => handleShowBatchItemsModal(batch.id)}>
            View Subscriptions
          </Button>
          <Button
            size="sm"
            variant="primary"
            onClick={() =>
              window.open(
                `${environment.baseUrl}/subscription_batch/${batch.id}`
              )
            }>
            Download CSV
          </Button>
        </div>
      ),
    },
  ];

  const emptyState = (
    <EmptyState
      icon="fas fa-layer-group"
      message="No subscription batches found"
    />
  );

  return (
    <Card className="shadow border-0">
      <div className="table-responsive">
        <DataTable
          columns={columns}
          data={safeBatches}
          loading={isLoading}
          emptyState={emptyState}
          skeletonRows={8}
        />
      </div>
    </Card>
  );
};

SubscriptionBatchList.propTypes = {
  subscriptionBatches: PropTypes.arrayOf(PropTypes.object),
  handleShowBatchItemsModal: PropTypes.func,
  isLoading: PropTypes.bool,
};

SubscriptionBatchList.defaultProps = {
  subscriptionBatches: [],
  handleShowBatchItemsModal: () => undefined,
  isLoading: false,
};

export default SubscriptionBatchList;
